
import { Mail } from 'lucide-react';

const NotificationSMTPInfo = () => {
  return (
    <div className="p-4 bg-muted/50 rounded-lg space-y-2">
      <h4 className="font-medium flex items-center gap-2">
        <Mail className="h-4 w-4" />
        Configuration SMTP MUCODEC
      </h4>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="font-medium">Serveur:</span> mail.mucodec.com
        </div>
        <div>
          <span className="font-medium">Port:</span> 25
        </div>
        <div>
          <span className="font-medium">Sécurité:</span> Non sécurisé
        </div>
        <div>
          <span className="font-medium">Expéditeur:</span> notification@mucodec.com
        </div>
      </div>
    </div>
  );
};

export default NotificationSMTPInfo;
